module.exports = __webpack_public_path__ + "static/media/hunter-bear.583b67f9.png";